const flagIcons = { 
    flag_eu: { backgroundPosition: '0 -128px !important' },
    flag_wf: { backgroundPosition: '0 -336px !important' },
    flag_ad: { backgroundPosition: '0 -352px !important' },
    flag_ae: { backgroundPosition: '0 -368px !important' },
    flag_af: { backgroundPosition: '0 -384px !important' },
    flag_ag: { backgroundPosition: '0 -400px !important' },
    flag_ai: { backgroundPosition: '0 -416px !important' },
    flag_al: { backgroundPosition: '0 -432px !important' },
    flag_am: { backgroundPosition: '0 -448px !important' },
    flag_ao: { backgroundPosition: '0 -464px !important' },
    flag_aq: { backgroundPosition: '0 -480px !important' },
    flag_ar: { backgroundPosition: '0 -496px !important' },
    flag_as: { backgroundPosition: '0 -512px !important' },
    flag_at: { backgroundPosition: '0 -528px !important' },
    flag_au: { backgroundPosition: '0 -544px !important' },
    flag_aw: { backgroundPosition: '0 -560px !important' },
    flag_ax: { backgroundPosition: '0 -576px !important' },
    flag_az: { backgroundPosition: '0 -592px !important' },
    flag_ba: { backgroundPosition: '0 -608px !important' },
    flag_bb: { backgroundPosition: '0 -624px !important' },
    flag_bd: { backgroundPosition: '0 -640px !important' },
    flag_be: { backgroundPosition: '0 -656px !important' },
    flag_bf: { backgroundPosition: '0 -672px !important' },
    flag_bg: { backgroundPosition: '0 -688px !important' },
    flag_bh: { backgroundPosition: '0 -704px !important' },
    flag_bi: { backgroundPosition: '0 -720px !important' },
    flag_bj: { backgroundPosition: '0 -736px !important' },
    flag_bm: { backgroundPosition: '0 -752px !important' },
    flag_bn: { backgroundPosition: '0 -768px !important' },
    flag_bo: { backgroundPosition: '0 -784px !important' },
    flag_br: { backgroundPosition: '0 -800px !important' },
    flag_bs: { backgroundPosition: '0 -816px !important' },
    flag_bt: { backgroundPosition: '0 -832px !important' },
    flag_bw: { backgroundPosition: '0 -848px !important' },
    flag_by: { backgroundPosition: '0 -864px !important' },
    flag_bz: { backgroundPosition: '0 -880px !important' },
    flag_ca: { backgroundPosition: '0 -896px !important' },
    flag_cg: { backgroundPosition: '0 -912px !important' },
    flag_cf: { backgroundPosition: '0 -928px !important' },
    flag_cd: { backgroundPosition: '0 -944px !important' },
    flag_ch: { backgroundPosition: '0 -960px !important' },
    flag_ci: { backgroundPosition: '0 -976px !important' },
    flag_ck: { backgroundPosition: '0 -992px !important' },
    flag_cl: { backgroundPosition: '0 -1008px !important' },
    flag_cm: { backgroundPosition: '0 -1024px !important' },
    flag_cn: { backgroundPosition: '0 -1040px !important' },
    flag_co: { backgroundPosition: '0 -1056px !important' },
    flag_cr: { backgroundPosition: '0 -1072px !important' },
    flag_cu: { backgroundPosition: '0 -1088px !important' },
    flag_cv: { backgroundPosition: '0 -1104px !important' },
    flag_cy: { backgroundPosition: '0 -1120px !important' },
    flag_cz: { backgroundPosition: '0 -1136px !important' },
    flag_de: { backgroundPosition: '0 -1152px !important' },
    flag_dj: { backgroundPosition: '0 -1168px !important' },
    flag_dk: { backgroundPosition: '0 -1184px !important' },
    flag_dm: { backgroundPosition: '0 -1200px !important' },
    flag_do: { backgroundPosition: '0 -1216px !important' },
    flag_dz: { backgroundPosition: '0 -1232px !important' },
    flag_ec: { backgroundPosition: '0 -1248px !important' },
    flag_ee: { backgroundPosition: '0 -1264px !important' },
    flag_eg: { backgroundPosition: '0 -1280px !important' },
    flag_eh: { backgroundPosition: '0 -1296px !important' },
    flag_er: { backgroundPosition: '0 -1312px !important' },
    flag_es: { backgroundPosition: '0 -1328px !important' },
    flag_et: { backgroundPosition: '0 -1344px !important' },
    flag_fi: { backgroundPosition: '0 -1360px !important' },
    flag_fj: { backgroundPosition: '0 -1376px !important' },
    flag_fm: { backgroundPosition: '0 -1392px !important' },
    flag_fo: { backgroundPosition: '0 -1408px !important' },
    flag_fr: { backgroundPosition: '0 -1424px !important' },
    flag_bl: { backgroundPosition: '0 -1424px !important' },
    flag_cp: { backgroundPosition: '0 -1424px !important' },
    flag_mf: { backgroundPosition: '0 -1424px !important' },
    flag_yt: { backgroundPosition: '0 -1424px !important' },
    flag_ga: { backgroundPosition: '0 -1440px !important' },
    flag_gb: { backgroundPosition: '0 -1456px !important' },
    flag_sh: { backgroundPosition: '0 -1456px !important' },
    flag_gd: { backgroundPosition: '0 -1472px !important' },
    flag_ge: { backgroundPosition: '0 -1488px !important' },
    flag_gg: { backgroundPosition: '0 -1504px !important' },
    flag_gh: { backgroundPosition: '0 -1520px !important' },
    flag_gi: { backgroundPosition: '0 -1536px !important' },
    flag_gl: { backgroundPosition: '0 -1552px !important' },
    flag_gm: { backgroundPosition: '0 -1568px !important' },
    flag_gn: { backgroundPosition: '0 -1584px !important' },
    flag_gp: { backgroundPosition: '0 -1600px !important' },
    flag_gq: { backgroundPosition: '0 -1616px !important' },
    flag_gr: { backgroundPosition: '0 -1632px !important' },
    flag_gt: { backgroundPosition: '0 -1648px !important' },
    flag_gu: { backgroundPosition: '0 -1664px !important' },
    flag_gw: { backgroundPosition: '0 -1680px !important' },
    flag_gy: { backgroundPosition: '0 -1696px !important' },
    flag_hk: { backgroundPosition: '0 -1712px !important' },
    flag_hn: { backgroundPosition: '0 -1728px !important' },
    flag_hr: { backgroundPosition: '0 -1744px !important' },
    flag_ht: { backgroundPosition: '0 -1760px !important' },
    flag_hu: { backgroundPosition: '0 -1776px !important' },
    flag_id: { backgroundPosition: '0 -1792px !important' },
    flag_mc: { backgroundPosition: '0 -1792px !important' },
    flag_ie: { backgroundPosition: '0 -1808px !important' },
    flag_il: { backgroundPosition: '0 -1824px !important' },
    flag_im: { backgroundPosition: '0 -1840px !important' },
    flag_in: { backgroundPosition: '0 -1856px !important' },
    flag_iq: { backgroundPosition: '0 -1872px !important' },
    flag_ir: { backgroundPosition: '0 -1888px !important' },
    flag_is: { backgroundPosition: '0 -1904px !important' },
    flag_it: { backgroundPosition: '0 -1920px !important' },
    flag_je: { backgroundPosition: '0 -1936px !important' },
    flag_jm: { backgroundPosition: '0 -1952px !important' },
    flag_jo: { backgroundPosition: '0 -1968px !important' },
    flag_jp: { backgroundPosition: '0 -1984px !important' },
    flag_ke: { backgroundPosition: '0 -2000px !important' },
    flag_kg: { backgroundPosition: '0 -2016px !important' },
    flag_kh: { backgroundPosition: '0 -2032px !important' },
    flag_ki: { backgroundPosition: '0 -2048px !important' },
    flag_km: { backgroundPosition: '0 -2064px !important' },
    flag_kn: { backgroundPosition: '0 -2080px !important' },
    flag_kp: { backgroundPosition: '0 -2096px !important' },
    flag_kr: { backgroundPosition: '0 -2112px !important' },
    flag_kw: { backgroundPosition: '0 -2128px !important' },
    flag_ky: { backgroundPosition: '0 -2144px !important' },
    flag_kz: { backgroundPosition: '0 -2160px !important' },
    flag_la: { backgroundPosition: '0 -2176px !important' },
    flag_lb: { backgroundPosition: '0 -2192px !important' },
    flag_lc: { backgroundPosition: '0 -2208px !important' },
    flag_li: { backgroundPosition: '0 -2224px !important' },
    flag_lk: { backgroundPosition: '0 -2240px !important' },
    flag_lr: { backgroundPosition: '0 -2256px !important' },
    flag_ls: { backgroundPosition: '0 -2272px !important' },
    flag_lt: { backgroundPosition: '0 -2288px !important' },
    flag_lu: { backgroundPosition: '0 -2304px !important' },
    flag_lv: { backgroundPosition: '0 -2320px !important' },
    flag_ly: { backgroundPosition: '0 -2336px !important' },
    flag_ma: { backgroundPosition: '0 -2352px !important' },
    flag_md: { backgroundPosition: '0 -2368px !important' },
    flag_me: { backgroundPosition: '0 -2384px !important' },
    flag_mg: { backgroundPosition: '0 -2400px !important' },
    flag_mh: { backgroundPosition: '0 -2416px !important' },
    flag_mk: { backgroundPosition: '0 -2432px !important' },
    flag_ml: { backgroundPosition: '0 -2448px !important' },
    flag_mm: { backgroundPosition: '0 -2464px !important' },
    flag_mn: { backgroundPosition: '0 -2480px !important' },
    flag_mo: { backgroundPosition: '0 -2496px !important' },
    flag_mq: { backgroundPosition: '0 -2512px !important' },
    flag_mr: { backgroundPosition: '0 -2528px !important' },
    flag_ms: { backgroundPosition: '0 -2544px !important' },
    flag_mt: { backgroundPosition: '0 -2560px !important' },
    flag_mu: { backgroundPosition: '0 -2576px !important' },
    flag_mv: { backgroundPosition: '0 -2592px !important' },
    flag_mw: { backgroundPosition: '0 -2608px !important' },
    flag_mx: { backgroundPosition: '0 -2624px !important' },
    flag_my: { backgroundPosition: '0 -2640px !important' },
    flag_mz: { backgroundPosition: '0 -2656px !important' },
    flag_na: { backgroundPosition: '0 -2672px !important' },
    flag_nc: { backgroundPosition: '0 -2688px !important' },
    flag_ne: { backgroundPosition: '0 -2704px !important' },
    flag_ng: { backgroundPosition: '0 -2720px !important' },
    flag_ni: { backgroundPosition: '0 -2736px !important' },
    flag_nl: { backgroundPosition: '0 -2752px !important' },
    flag_bq: { backgroundPosition: '0 -2752px !important' },
    flag_no: { backgroundPosition: '0 -2768px !important' },
    flag_bv: { backgroundPosition: '0 -2768px !important' },
    flag_nq: { backgroundPosition: '0 -2768px !important' },
    flag_sj: { backgroundPosition: '0 -2768px !important' },
    flag_np: { backgroundPosition: '0 -2784px !important' },
    flag_nr: { backgroundPosition: '0 -2800px !important' },
    flag_nz: { backgroundPosition: '0 -2816px !important' },
    flag_om: { backgroundPosition: '0 -2832px !important' },
    flag_pa: { backgroundPosition: '0 -2848px !important' },
    flag_pe: { backgroundPosition: '0 -2864px !important' },
    flag_pf: { backgroundPosition: '0 -2880px !important' },
    flag_pg: { backgroundPosition: '0 -2896px !important' },
    flag_ph: { backgroundPosition: '0 -2912px !important' },
    flag_pk: { backgroundPosition: '0 -2928px !important' },
    flag_pl: { backgroundPosition: '0 -2944px !important' },
    flag_pr: { backgroundPosition: '0 -2960px !important' },
    flag_ps: { backgroundPosition: '0 -2976px !important' },
    flag_pt: { backgroundPosition: '0 -2992px !important' },
    flag_pw: { backgroundPosition: '0 -3008px !important' },
    flag_py: { backgroundPosition: '0 -3024px !important' },
    flag_qa: { backgroundPosition: '0 -3040px !important' },
    flag_re: { backgroundPosition: '0 -3056px !important' },
    flag_ro: { backgroundPosition: '0 -3072px !important' },
    flag_rs: { backgroundPosition: '0 -3088px !important' },
    flag_ru: { backgroundPosition: '0 -3104px !important' },
    flag_rw: { backgroundPosition: '0 -3120px !important' },
    flag_sa: { backgroundPosition: '0 -3136px !important' },
    flag_sb: { backgroundPosition: '0 -3152px !important' },
    flag_sc: { backgroundPosition: '0 -3168px !important' },
    flag_sd: { backgroundPosition: '0 -3184px !important' },
    flag_se: { backgroundPosition: '0 -3200px !important' },
    flag_sg: { backgroundPosition: '0 -3216px !important' },
    flag_si: { backgroundPosition: '0 -3232px !important' },
    flag_sk: { backgroundPosition: '0 -3248px !important' },
    flag_sl: { backgroundPosition: '0 -3264px !important' },
    flag_sm: { backgroundPosition: '0 -3280px !important' },
    flag_sn: { backgroundPosition: '0 -3296px !important' },
    flag_so: { backgroundPosition: '0 -3312px !important' },
    flag_sr: { backgroundPosition: '0 -3328px !important' },
    flag_st: { backgroundPosition: '0 -3344px !important' },
    flag_sv: { backgroundPosition: '0 -3360px !important' },
    flag_sy: { backgroundPosition: '0 -3376px !important' },
    flag_sz: { backgroundPosition: '0 -3392px !important' },
    flag_tc: { backgroundPosition: '0 -3408px !important' },
    flag_td: { backgroundPosition: '0 -3424px !important' },
    flag_tg: { backgroundPosition: '0 -3440px !important' },
    flag_th: { backgroundPosition: '0 -3456px !important' },
    flag_tj: { backgroundPosition: '0 -3472px !important' },
    flag_tl: { backgroundPosition: '0 -3488px !important' },
    flag_tm: { backgroundPosition: '0 -3504px !important' },
    flag_tn: { backgroundPosition: '0 -3520px !important' },
    flag_to: { backgroundPosition: '0 -3536px !important' },
    flag_tr: { backgroundPosition: '0 -3552px !important' },
    flag_tt: { backgroundPosition: '0 -3568px !important' },
    flag_tv: { backgroundPosition: '0 -3584px !important' },
    flag_tw: { backgroundPosition: '0 -3600px !important' },
    flag_tz: { backgroundPosition: '0 -3616px !important' },
    flag_ua: { backgroundPosition: '0 -3632px !important' },
    flag_ug: { backgroundPosition: '0 -3648px !important' },
    flag_us: { backgroundPosition: '0 -3664px !important' },
    flag_uy: { backgroundPosition: '0 -3680px !important' },
    flag_uz: { backgroundPosition: '0 -3696px !important' },
    flag_va: { backgroundPosition: '0 -3712px !important' },
    flag_vc: { backgroundPosition: '0 -3728px !important' },
    flag_ve: { backgroundPosition: '0 -3744px !important' },
    flag_vg: { backgroundPosition: '0 -3760px !important' },
    flag_vi: { backgroundPosition: '0 -3776px !important' },
    flag_vn: { backgroundPosition: '0 -3792px !important' },
    flag_vu: { backgroundPosition: '0 -3808px !important' },
    flag_ws: { backgroundPosition: '0 -3824px !important' },
    flag_ye: { backgroundPosition: '0 -3840px !important' },
    flag_za: { backgroundPosition: '0 -3856px !important' },
    flag_zm: { backgroundPosition: '0 -3872px !important' },
    flag_zw: { backgroundPosition: '0 -3888px !important' },
    flag_sx: { backgroundPosition: '0 -3904px !important' },
    flag_cw: { backgroundPosition: '0 -3920px !important' },
    flag_ss: { backgroundPosition: '0 -3936px !important' },
};

export default flagIcons;
